import React from "react";
import { Navigate } from "react-router-dom";
import { getDecodedUserData } from "./Utils"; // ajuste o caminho conforme necessário

const ProtectedRoute = ({ children }) => {
    
  const userData = getDecodedUserData();
  const isAuthenticated = !!userData?.CompanyPersonCompleteName; // ajuste se necessário

  return isAuthenticated ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
